import { SERVER_URL } from "../../api";
import axios from 'axios'
import { getHeaderWithToken } from "../../helpers/func";
export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const RESET_SEARCH = 'RESET_SEARCH';
let cancelToken = axios.CancelToken;
let cancel;


export const search = (data) => {
    let headers = getHeaderWithToken();
    cancel && cancel();

    return dispatch => {
        return new Promise(function (resolve, reject) {

            dispatch({
                type: SEARCH_REQUEST
            })
            axios({
                method: 'POST',
                url: `${SERVER_URL}v1/patterns/search`,
                cancelToken: new cancelToken(can => {
                    cancel = can;
                }),
                headers: headers,
                data: data
            }).then(function (response) {
                dispatch({
                    type: SEARCH_SUCCESS,
                    payload: response
                })
                resolve(response);

            })
                .catch(function (error) {
                    dispatch({
                        type: SEARCH_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}

export const resetAddSizeData = () => {
    return dispatch => {
        dispatch({
            type: RESET_SEARCH
        })
    }
}

